var _path, _path2, _path3, _path4, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsbShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.2794C9 16.6713 10.3036 15.3677 11.9118 15.3677H29.3824C30.9905 15.3677 32.2941 16.6713 32.2941 18.2794V41.5736C32.2941 44.7898 29.6868 47.3971 26.4706 47.3971H14.8235C11.6073 47.3971 9 44.7898 9 41.5736V18.2794Z",
    fill: "url(#paint0_linear_7240_24230)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2354 7.69106C13.2354 6.08294 14.539 4.7793 16.1471 4.7793H25.1471C26.7552 4.7793 28.0589 6.08294 28.0589 7.69106V15.3675H13.2354V7.69106Z",
    fill: "url(#paint1_linear_7240_24230)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4115 48.7206C34.4115 48.7206 44.9997 43.4265 44.9997 35.4853V26.2206L34.4115 22.25L23.8232 26.2206V35.4853C23.8232 43.4265 34.4115 48.7206 34.4115 48.7206Z",
    fill: "url(#paint2_linear_7240_24230)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1172 34.4265L33.3525 38.6618L39.7054 32.3088",
    stroke: "white",
    strokeWidth: 1.48235,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.4121,
    y: 11.1323,
    width: 3.17647,
    height: 1.05882,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7061,
    y: 11.1323,
    width: 3.17647,
    height: 1.05882,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24230",
    x1: 20.6471,
    y1: 15.3677,
    x2: 20.6471,
    y2: 47.3971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B297FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5061FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24230",
    x1: 20.6471,
    y1: 4.7793,
    x2: 20.6471,
    y2: 15.3675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D72DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7240_24230",
    x1: 26.4703,
    y1: 20.6618,
    x2: 39.7056,
    y2: 49.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08EBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#21FEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1875E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsbShield);
export default __webpack_public_path__ + "static/media/icon_usb_shield.a429a6d1b467076f54a74a73070b38c5.svg";
export { ForwardRef as ReactComponent };